import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
export const frontmatter = {
  "title": "A Biography",
  "slug": "petri-lahdelma-bio",
  "publishedAt": "2025-06-15T00:00:00.000Z",
  "readTime": "3 min read",
  "excerpt": "From a small suburb to leading global design systems.",
  "seoDescription": "A biography of Petri Lahdelma, a Finnish designer and systems thinker: from a suburb of Turku through two decades of agencies, startups and design systems.",
  "authorName": "Petri Lahdelma",
  "authorSlug": "petri-lahdelma"
};
function _createMdxContent(props) {
  const _components = {
    p: "p",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "Petri Lahdelma is a Finnish designer, systems thinker and advocate for professional ethics in design. Raised in Varissuo, a suburb of Turku, his passion for visual culture came from a painter father and a supportive mother. That early spark carried him to the UK for a BA in Graphic Design at the University of Cumbria and later to Aalto University in Helsinki for a master's degree."
    }), "\n", _jsx(_components.p, {
      children: "Two mentors shaped his craft. Rhiannon Robinson sharpened his critical eye. Tapio Vapaasalo instilled a love for craftsmanship and form. After a junior stint at Werklig, Petri spent two decades moving through agencies, startups and entrepreneurial ventures, always refusing to stand still."
    }), "\n", _jsx(_components.p, {
      children: "Today he leads a design system team in a global enterprise of more than 110,000 colleagues worldwide, balancing enterprise UX with scalable systems thinking. His portfolio ranges from national infrastructure identities like the Liikennevirasto corporate identity to agile startup brands such as New Things Company. He laid the strategic groundwork for the Helsinki Design System."
    }), "\n", _jsx(_components.p, {
      children: "Throughout his career Petri has founded and led design guilds and special interest programs, shaping team culture as much as the work itself. He belongs to AIGA, IxDA and ISTD. While he rarely speaks publicly, a regret of his own, his influence lives in the systems, standards and ethics he brings to every project."
    }), "\n", _jsx(_components.p, {
      children: "He believes clarity matters more than decoration, that form follows function and that users seldom say what they really need. Guided by curiosity and care rather than fleeting trends, colleagues know him as a thoughtful, kind collaborator who insists on doing things the right way."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
